/**
 * Returns true when url is safe to open in a new tab or set as href.
 * Accepts absolute http/https URLs and same-origin relative paths (/foo, ./bar).
 * Rejects javascript:, data:, vbscript:, and any other scheme.
 */
export function isSafeUrl(url?: string): url is string {
  if (!url) return false;
  if (url.startsWith('//')) return false;
  if (url.startsWith('/') || url.startsWith('./') || url.startsWith('../'))
    return true;
  try {
    const { protocol } = new URL(url);
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
}
